<p>ui-breadcrumb works!</p>
